import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialGroupLaboratoryContractApi = {
    getTrialGroupLaboratoryContractByTrialGroupLaboratoryId: (trialGroupLaboratoryId: number): Observable<Dtos.GetTrialGroupLaboratoryContractByTrialGroupLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupLaboratoryContractByTrialGroupLaboratoryId = new Dtos.GetTrialGroupLaboratoryContractByTrialGroupLaboratoryId();
        request.trialGroupLaboratoryId = trialGroupLaboratoryId;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupLaboratoryContractByTrialGroupLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupLaboratoryContractById: (id: number): Observable<Dtos.GetTrialGroupLaboratoryContractByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupLaboratoryContractById = new Dtos.GetTrialGroupLaboratoryContractById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupLaboratoryContractByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialGroupLaboratoryContract: (trialGroupLaboratoryContract: Dtos.TrialGroupLaboratoryContract): Observable<Dtos.SetTrialGroupLaboratoryContractResponse> => {

        let request: Dtos.SetTrialGroupLaboratoryContract = new Dtos.SetTrialGroupLaboratoryContract();

        request.trialGroupLaboratoryContract = trialGroupLaboratoryContract;

        // send request
        const response: Promise<Dtos.SetTrialGroupLaboratoryContractResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialGroupLaboratoryContract: (trialGroupLaboratoryId: number): Observable<Dtos.CreateTrialGroupLaboratoryContractResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialGroupLaboratoryContract = new Dtos.CreateTrialGroupLaboratoryContract();

        request.trialGroupLaboratoryId = trialGroupLaboratoryId;

        //Send request.
        const response: Promise<Dtos.CreateTrialGroupLaboratoryContractResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialGroupLaboratoryContract: (trialGroupLaboratoryContract: Dtos.TrialGroupLaboratoryContract): Observable<Dtos.ValidateTrialGroupLaboratoryContractResponse> => {

        let request: Dtos.ValidateTrialGroupLaboratoryContract = new Dtos.ValidateTrialGroupLaboratoryContract();

        request.trialGroupLaboratoryContract = trialGroupLaboratoryContract;

        // send request
        const response: Promise<Dtos.ValidateTrialGroupLaboratoryContractResponse> = client.post(request);

        return Observable.from(response);
    },
    deleteTrialGroupLaboratoryContract: (id: number): Observable<Dtos.DeleteTrialGroupLaboratoryContractResponse> => {
        //Create the request.
        let request: Dtos.DeleteTrialGroupLaboratoryContract = new Dtos.DeleteTrialGroupLaboratoryContract();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.DeleteTrialGroupLaboratoryContractResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
}